import { pWarn } from '_/helpers/logger'
import { errorTypes } from '_/services/errorTypes'
import _ from 'lodash'

/**
 * Binds Parsley validator to form
 *
 * @param   {object}  options
 * @return  {object}
 */
export const bindValidatorToForm = options => {
  return $(options.selector)
    .parsley()
    .on('form:submit', function() {
      if (typeof options.onSubmit === 'function') {
        options.onSubmit()
      }

      return false
    })
}

/**
 * Resets provided validator
 *
 * @param   {object}  validator
 * @return  {void}
 */
export const resetValidator = validator => {
  removeValidatorErrors(validator)

  validator.reset()
}

/**
 * Destroys provided validator
 *
 * @param   {object}  validator
 * @return  {void}
 */
export const destroyValidator = validator => {
  if (!_.has(validator, '$element')) {
    return
  }

  removeValidatorErrors(validator)

  validator.destroy()
}

export const removeValidatorErrors = validator => {
  validator.$element.find('.form-field-error').each(function() {
    $(this)
      .parsley()
      .removeError($(this).attr('id'))
  })
}

/**
 * Processes API error message and errors from error fields object
 *
 * @param   {object}  validator
 * @param   {object}  errorObject
 * @return  {string}
 */
export const processErrors = (validator, errorObject) => {
  if (errorObject.fields) {
    parseFieldsErrors(validator, errorObject.fields)
  }

  let errorMessage = ''

  // Try translating a message returned by the API using errorTypes else use the unprocessed API message
  if (errorObject.message) {
    errorMessage = errorTypes[errorObject.message] || errorObject.message
  }

  return errorMessage
}

/**
 * Parses fields error object
 *
 * @param   {object}  validator
 * @param   {object}  errorFields
 * @return  {[type]}  [description]
 */
export const parseFieldsErrors = (validator, errorFields) => {
  const fieldsArray = []
  for (const field in errorFields) {
    fieldsArray.push(field)
  }
  for (let i = 0; i < fieldsArray.length; i++) {
    const field = fieldsArray[i]
    if (_.has(errorFields, field)) {
      let fieldInDashNotation = field.replaceAll('.', '-')
      let $formElementToValidate = validator.$element.find(
        '[id="' + fieldInDashNotation + '-error"]'
      )

      if (!$formElementToValidate.length) {
        pWarn(
          'No such field name found while parsing fields error object',
          fieldInDashNotation
        )
        continue
      }

      let message = errorTypes.translateFieldError(
        _.get(errorFields[field], 'message', errorFields[field])
      )

      $formElementToValidate
        .parsley()
        .addError(fieldInDashNotation + '-error', { message })

      const nativeInputElement = document.getElementById(
        `${fieldInDashNotation}-wrapper`
      )
      const $fieldWrapper = $(nativeInputElement)
      const $input = $fieldWrapper.find('input')
      $input.addClass('parsley-error')

      if (i === 0) {
        $input.focus()
        nativeInputElement.scrollIntoView({
          block: 'center',
        })
      }
    }
  }
}
